module.exports = __webpack_public_path__ + "static/parker-coulter-footer-logo-795531d4db70436ec71a731020cde9b9.png";